<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@switch (dataSource.reportSubType$ | async) {
  @case ('detail') {
    <dash-gis-report-content-print-detail [definition]="definition"
      [keys]="keys"
    [dataSource]="dataSource"></dash-gis-report-content-print-detail>
  }
  @case ('tabular') {
    <dash-gis-report-content-print-tabular [definition]="definition"
      [keys]="keys"
    [dataSource]="dataSource"></dash-gis-report-content-print-tabular>
  }
  @case ('chart') {
    <dash-gis-report-content-chart [definition]="definition"
      [keys]="keys"
      [dataSource]="dataSource"
      [isPrinting]="true"
    fxLayout="column" fxFill></dash-gis-report-content-chart>
  }
  @case ('label') {
    <dash-gis-report-content-pdf [definition]="definition"
      [keys]="keys"
    [dataSource]="dataSource"></dash-gis-report-content-pdf>
  }
  @default {
    <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
  }
}

<!-- empty -->
<ng-template #emptyTemplate>
  <div>No records found</div>
</ng-template>

